define("madRemoveJsComments",[],(function(){"use strict";return function(e){return e?e.replace(/\/\*[\s\S]*?\*\//g,""):""}}));
